<script>
import { currencyFormat } from '../../helpers/currencyFormat';

export default {
  props: {
    name: {
      type: String,
      requried: false,
      default: '',
    },

    price: {
      type: [
        String, Number,
      ],
      default: '',
      required: false,
    },

    installments: {
      type: [
        String, Number,
      ],
      default: '',
      required: false,
    }
  },

  computed: {
    _price () {
      return currencyFormat(this.price, 2, 'decimal');
    }
  }
};
</script>

<template>
  <div
    @click="$emit('selected')"
    class="bdk-relative bdk-block bdk-rounded-lg bdk-border bdk-border-gray-300 bdk-bg-white bdk-shadow-sm bdk-px-6 bdk-py-4 bdk-cursor-pointer hover:bdk-border-indigo-500 sm:bdk-flex sm:bdk-justify-between focus:bdk-outline-none bdk-border-solid bdk-mt-2"
  >
    <div
      class="bdk-flex bdk-items-center bdk-flex-grow"
    >
      <div
        class="bdk-text-sm"
      >
        <span
          v-text="name"
          class="bdk-font-medium bdk-text-gray-900 bdk-block"
        />

        <div
          class="bdk-text-gray-500 bdk-flex"
        >
          <p
            v-text="`${__('Preço')}: ${_price}`"
          />

          <template
            v-if="installments && installments > 1"
          >
            <span
              aria-hidden="true"
              class="bdk-hidden sm:bdk-inline sm:bdk-mx-1"
            >
              &middot;
            </span>

            <p
              v-text="`${__('Parcelamento Máximo')}: ${installments}`"
            />
          </template>
        </div>
      </div>

      <div
        class="bdk-ml-auto"
        @click.prevent.stop="$emit('edit')"
      >
        <svg class="bdk-h-6 bdk-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      </div>
    </div>
  </div>
</template>
